<template>
    <div id="history-account-status">
        <main id="mainContent" class="padFixBoth">
            <div class="mt-4">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12 col-sm-12 mt-4">
                            <div class="view">
                                <h2 class="cabeza">Control de consulta sin Facturar</h2>
                                <b-table responsive id="my-table" striped hover :fields="fields_sinister" :busy="isBusy"
                                         :items="pagination_sinister.data">
                                         <template #cell(Registrado)="{item}">
                                        <div>
                                            {{ moment(item.created_at).format('DD/MM/YYYY') }}
                                        </div>
                                    </template>
                                    <template #cell(Fecha_Atencion)="{item}">
                                        <div>
                                            {{ moment(item.fecha_atencion).format('DD/MM/YYYY') }}
                                        </div>
                                    </template>
                                    <template #cell(Paciente)="{item}">
                                        {{ item.sku }}
                                    </template>

                                    <template #cell(Honorarios)="{item}">
                                    <span v-if="item.relsupplier">
                                        {{ formatPrice(item.relsupplier.honorarios) }}
                                    </span>
                                    </template>

                                    <template #cell(Isr)="{item}">
                                        <span v-if="item.relsupplier"></span> {{ formatPrice(isr) }}
                                    </template>

                                    <template #cell(total)="{item}">
                                        {{ formatPrice(total) }}
                                    </template>

                                    <template #table-busy>
                                        <div class="text-center text-danger my-2">
                                            <b-spinner class="align-middle"></b-spinner>
                                            <strong>Loading...</strong>
                                        </div>
                                    </template>
                                </b-table>

                                <div
                                    style="background-color: #0069a7; color: #fff; text-align: center; padding: 10px 0; text-transform: uppercase;">
                                    total a facturar - <span>{{ globalTotal }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-12 mt-4">
                            <div class="view">
                                <h2 class="cabeza">Control de consulta Facturados sin pagar</h2>
                                <b-table
                                    responsive
                                    id="my-table"
                                    striped hover
                                    :fields="fields_bills"
                                    :busy="isBusy"
                                    :items="pagination_bills.data">

                                    <template #cell(Paciente)="{item}">
                                        <div v-for="(sinister, index) in item.sinister" :key="index">
                                            <span>
                                                {{ sinister.sku }}
                                            </span>
                                        </div>
                                    </template>
                                    <template #cell(Factura)="{item}">
                                        {{ item.factura_name }}
                                    </template>

                                    <template #cell(Concepto)="{item}">
                                        {{ item.concepto }}
                                    </template>
                                    <template #cell(Subtotal)="{item}">
                                        {{ item.subtotal }}
                                    </template>

                                    <template #cell(Iva)="{item}">
                                        {{ item.iva }}
                                    </template>

                                    <template #cell(total)="{item}">
                                        {{ item.total }}
                                    </template>

                                    <template #table-busy>
                                        <div class="text-center text-danger my-2">
                                            <b-spinner class="align-middle"></b-spinner>
                                            <strong>Loading...</strong>
                                        </div>
                                    </template>
                                </b-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import {myMixins} from "../mixins/myMixins";
import {sinisterService} from "../../Services/Sinister.service";
import {invoicesService} from "../../Services/Invoices.service";
import moment from 'moment';

export default {
    name: "history-account-status",
    mixins: [myMixins],
    props: {
        user_id: {
            type: Number,
            default: 0,
            require: false
        },
        role_id: {
            type: Number,
            default: 0,
            require: true
        }
    },
    data() {
        return {
            isBusy: false,
            filter: null,
            quotings: [],
            fields_sinister: [
                {key: 'Registrado'},
                {key: 'Fecha_Atencion'},
                {key: 'Paciente'},
                {key: 'Honorarios'},
                {key: 'Isr'},
                {key: 'Total'},
            ],
            fields_bills: [
                {key: 'Paciente'},
                {key: 'Factura'},
                {key: 'Concepto'},
                {key: 'Subtotal'},
                {key: 'Iva'},
                {key: 'Total'},
            ],
            pagination_sinister: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            pagination_bills: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            params_sinister: {
                limit: 100,
                page: 1,
                where: [],
            },
            params_inovoice: {
                limit: 10,
                page: 1,
                where: [],
            },
            type_per: []

        }
    },
    methods: {
        moment: function(date) {
        return moment(date);
    },
        async index() {
            this.isBusy = true;
            //FIND THE BILLS OF SINISTER NOT PAID
            let getModel = this.roleModels[this.role_id];
            this.params_sinister.where = [
                {
                    field: 'supplier_id',
                    value: this.user_id,
                    operator: '='
                },
                {
                    field: 'model_type',
                    value: 'App\\Models\\' + getModel,
                    operator: '='
                },
                {
                    field: 'paid_at',
                    value: 0,
                    operator: '='
                }
            ];
            this.params_inovoice.where = [
                {
                    field: 'supplier_id',
                    value: this.user_id,
                    operator: '='
                },
                {
                    field: 'model_type',
                    value: 'App\\Models\\' + getModel,
                    operator: '='
                },
                {
                    field: 'ticket_admin',
                    value: 0,
                    operator: '='
                }
            ];
            this.pagination_sinister = await sinisterService.getMany(this.params_sinister);
            this.pagination_bills = await invoicesService.getMany(this.params_inovoice);
            this.isBusy = false;

        },
        onChange(page) {
            this.params.page = page;
            this.index();
        },
        changeLimit() {
            this.index();
        },
    },
    computed: {
        isr() {
            return this.pagination_sinister.data.reduce((total, item) => (Number(item.relsupplier.honorarios || 0) * Number(item.relsupplier.isr || 0)), 0);
        },
        total() {
            return this.pagination_sinister.data.reduce((total, item, index) => (Number(item.relsupplier.honorarios || 0) - this.isr), 0);
        },
        globalTotal() {
            return this.formatPrice(
                this.pagination_sinister.data.reduce((total, item) => total + this.total, 0)
            );
        }
    },
    mounted() {
        this.index();
    }
}
</script>

<style scoped>
</style>
